'use client';

import React, { useEffect } from 'react';

import { GSAPProvider } from '@/providers/GSAPProvider';
import { ScrollProvider } from '@/providers/ScrollLengthContextProvider';

import { initializeAmplitude } from '@/lib/analytics/amplitude';

export function Providers({ children }) {
  useEffect(() => {
    initializeAmplitude();
  }, []);

  return (
    <GSAPProvider>
      <ScrollProvider>{children}</ScrollProvider>
    </GSAPProvider>
  );
}
